import { useQuery } from "@tanstack/react-query";
import axios from "axios";

import { __API_URL__ } from "../SERVER_URL";

const fetchAppVideosSummary = async ({ patientId, trialId }) => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${__API_URL__}/api/photos/get_app_videos_summary/`, {
    params: {
      patientId,
      trialId,
    },
    headers: {
      Authorization: `Token ${token}`,
    },
  });
  return response.data;
};

const useGetAppVideosSummary = ({ patientId, trialId, enabled = true }) => {
  return useQuery({
    queryKey: ["app-videos-summary", patientId, trialId],
    queryFn: () => fetchAppVideosSummary({ patientId, trialId }),
    enabled: enabled && Boolean(patientId) && Boolean(trialId),
  });
};

export default useGetAppVideosSummary;
